(ns frontend.subscription
  (:require
   [common.time :as c-time]
   [common.timer :as timer]
   [frontend.conn :as c]
   [re-frame.core :as rf]
   [frontend.logging :as logging]))

;;
;; Subscriptions:
;;

(defonce subscriptions (atom {}))

;;
;; Misc utils:
;;

(defn- new-subscription
  [{rev :rev} key type opts on-update]
  {:key       key
   :rev       (if rev (inc rev) (.getTime (js/Date.)))
   :type      type
   :opts      opts
   :on-update on-update})

;;
;; Public API:
;;

(defn open
  ([key type opts on-update]
   (open key type opts on-update identity))
  ([key type opts on-update on-error]
   {:pre [(keyword? key)
          (keyword? type)
          (ifn? on-update)]}
   (let [opts (merge opts {:client-time (c-time/now-millis)})
         timer (timer/create-timer)
         rev (-> subscriptions
                 (swap! update key new-subscription key type opts on-update)
                 key
                 :rev)]
     (c/send!
      :subscription/open
      {:key  key
       :rev  rev
       :type type
       :opts opts}
      (fn [{:keys [error] :as resp}]
        (if error
          (do (logging/warn "Error opening the subscription: " (pr-str key) ": " (pr-str error))
              (on-error error))
          (logging/info "Subscription opened " key ", timer" (timer) " < " resp))
        :ok)))))

(defn close
  ([key]
   (close key nil))
  ([key cb!]
   (if-not (get @subscriptions key)
     (when cb!
       (cb! {:error (str "No such subscription " key)}))
     (do
       (swap! subscriptions dissoc key)
       (c/send! :subscription/close
                {:key key}
                (fn [resp]
                  (when cb!
                    (cb! resp))))))))

;;
;; Handle subcriptions data updates:
;;

(defn subscription-update
  [{:keys [key rev updates] :as e}]
  (let [s (get @subscriptions key)]
    (when (-> s
              :rev
              (= rev))
      ((:on-update s) updates))))

;;
;; Renew and reset:
;;

(defn renew-subscriptions
  []
  (doseq [subscription (-> subscriptions
                           (swap! (partial reduce-kv
                                           (fn [acc key subscription]
                                             (assoc acc key (update subscription :rev inc)))
                                           {}))
                           (vals))]
    (c/send! :subscription/open
             (assoc (select-keys subscription [:key :rev :type :opts])
                    :opts
                    (merge (:opts subscription)
                           {:client-time (c-time/now-millis)})))))

(defn reset-subscriptions
  []
  (doseq [key (keys @subscriptions)]
    (c/send! :subscription/close {:key key}))
  (reset! subscriptions {}))

(defonce registry {:subscription/subscription-update subscription-update})

(defn dispatch-updates
  [env request-id & args]

  (let [response (try
                   (if-let [registry-fn (get registry request-id)]
                     (apply registry-fn args)
                     (when (and request-id
                                (not (some #{request-id} [:error])))
                       (logging/warn "No function for event " (pr-str request-id))))
                   (catch js/Object e
                     (logging/error "Error dispatching updates :" e)))
        response-to-be-sent
        (cond
          (map? response) (do (when (= :local @env)
                                (logging/warn "Sending response to server " response))
                              response)
          (fn? response) (do (logging/error "updates response is a function " request-id
                                            " ->> " args)
                             :ok)
          (keyword? response) response
          (nil? response) :ok
          :else (do (logging/error "Unkonwn response to updates " response)
                    :ok))]
    {:body response-to-be-sent}))


(defn open-subscription-fx
  [{:keys [key type opts on-update-event on-error-event
           close-previous-subscription-if-exists?
           signal]}]
  ;; TODO: Should we use optional AbortController signal here to
  ;; automatically close the subscription on abort?
  (assert (vector? on-update-event) "on-update-event must be a vector")
  (assert (vector? on-error-event) "on-error-event must be a vector")
  (let [on-update-fn (fn [update-msg]
                       (rf/dispatch (conj on-update-event update-msg)))
        on-error-fn (fn [err]
                      (rf/dispatch (conj on-error-event err)))
        open-sub-fn (fn [args]
                      (open key type opts on-update-fn on-error-fn))]
    (if close-previous-subscription-if-exists?
      (close key open-sub-fn)
      (open-sub-fn nil))))

(defn close-subscription-fx
  [{:keys [key callback-event]}]
  (let [callback-fn (fn [msg]
                      (rf/dispatch (conj callback-event msg)))]
    (close key callback-fn)))


(rf/reg-fx ::open open-subscription-fx)
(rf/reg-fx ::close close-subscription-fx)

